const apiUrl = process.env.REACT_APP_API_URL;
export const GetInteraccionsHistory = async (id_user: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id_user}/interaccions/history`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
